import React from "react";
import PropTypes from "prop-types";
import { FaTrash, FaPen, FaPlus } from "react-icons/fa";
import Button from "./Button";
import "../styles/reviews.css";

const UnitFiltersSection = ({ unitFilters, onAdd, onEdit, onDelete }) => {
  return (
    <div className="unit-filters-section-fullwidth">
      <div className="unit-filters-header-row">
        <h2>Unit Filters</h2>
        <Button
          title={
            <>
              <FaPlus style={{ marginRight: 6 }} />
              Add unit filter
            </>
          }
          className="float-right mb-2"
          onPress={onAdd}
          typeBtn="primary"
        />
      </div>
      <table className="reviews-table">
        <thead>
          <tr>
            <th>Number</th>
            <th>Name</th>
            <th>Key</th>
            <th></th>
          </tr>
        </thead>
        <tbody>
          {unitFilters.map((review, idx) => (
            <tr key={idx}>
              <td>{idx + 1}</td>
              <td>{review.name}</td>
              <td>{review.filter_key}</td>
              <td>
                <view className="actions">
                  <span className="action-btn text-success px-1" title="Edit" onClick={() => onEdit && onEdit(idx)}>
                    <FaPen />
                  </span>
                  <span
                    className="action-btn text-danger px-1"
                    title="Delete"
                    onClick={() => onDelete && onDelete(idx)}
                  >
                    <FaTrash />
                  </span>
                </view>
              </td>
            </tr>
          ))}
        </tbody>
      </table>
    </div>
  );
};

UnitFiltersSection.propTypes = {
  unitFilters: PropTypes.arrayOf(
    PropTypes.shape({
      name: PropTypes.string.isRequired,
      location: PropTypes.string.isRequired,
      description: PropTypes.string.isRequired,
      picture: PropTypes.string.isRequired,
    })
  ).isRequired,
};

export default UnitFiltersSection;
